import React, {Dispatch, SetStateAction} from 'react';
import s from '../MyOrdersForManager.module.css';
import MyOrdersManagerFilter from '../../../Components/Filter/OrdersFilters/MyOrdersManagerFilter';
import MyOrdersListStoreFilter from '../../../Components/Filter/OrdersFilters/MyOrdersListStoreFilter';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';
import {
	OrderInfo,
	RequestOrdersDataType,
	ResponseOrdersDataType,
} from '../../../types/TypesUserOrders';
import OrderRowElNew, {OrderRowType} from './OrderRowElNew';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import ShoppingTotal from '../../../Components/ShoppingTotal/ShoppingTotal';
import {useTranslation} from 'react-i18next';
import useClickMoreButton from '../../../hooks/useClickMoreButton';

type Props = {
	data: ResponseOrdersDataType;
	setFilters: Dispatch<SetStateAction<RequestOrdersDataType>>;
	columns: string[];
	type: OrderRowType;
};
const MyOrdersNewApiTable: React.FC<Props> = ({
	data,
	setFilters,
	columns,
	type,
}) => {
	const {t} = useTranslation();
	const {handleClickMoreButton} = useClickMoreButton(setFilters);

	return (
		<>
			<div className={s.filterContainer}>
				{type === 'list-store' ? (
					<MyOrdersListStoreFilter setFilters={setFilters} />
				) : (
					<MyOrdersManagerFilter setFilters={setFilters} />
				)}
			</div>
			{/* Обгортка для горизонтального скролу тільки таблиці */}
			<div className={s.tableWrapper}>
				<div className={s.tableGrid}>
					<GridTableHead 
						columns={columns} 
						customClassName={s.tableRow}
					/>
					{data.orders?.map((order: OrderInfo, index: number) => (
						<OrderRowElNew
							order={order}
							index={index}
							key={order.id}
							type={type}
						/>
					))}
					{data.count_orders % 10 === 0 && (
						<div className={s.buttonWrapper}>
							<LightGreenButton
								type={'button'}
								onClick={handleClickMoreButton}
								text={t('дивитися більше')}
							/>
						</div>
					)}
				</div>
			</div>
			<div className={s.totalWrapper}>
				<ShoppingTotal
					sumMoney={data.sum_money}
					sumBonuses={data.sum_points}
					count={data.count_orders}
				/>
			</div>
		</>
	);
};

export default MyOrdersNewApiTable;
